import {AnimatePresence, motion} from "framer-motion"
import React, {Dispatch, SetStateAction} from "react"

import styles from "../FeaturesGrid.module.scss"

type DefaultNavigationArrowsProps<T> = {
	activeIndex: number | null
	data: T[]
	setActiveIndex: Dispatch<SetStateAction<number | null>>
}

function DefaultNavigationArrows<T>({
	activeIndex,
	data,
	setActiveIndex,
}: DefaultNavigationArrowsProps<T>) {
	if (data.length <= 1) return null

	return (
		<AnimatePresence>
			{activeIndex !== null && (
				<motion.div
					animate={{opacity: 1}}
					className={styles.popupOverlayButtons}
					exit={{opacity: 0}}
					initial={{opacity: 0}}
					transition={{duration: 0.2}}
				>
					<motion.button
						className={styles.navArrowLeft}
						onClick={(e: any) => {
							e.stopPropagation()
							setActiveIndex((prev) =>
								typeof prev === "number"
									? (prev - 1 + data.length) % data.length
									: data.length - 1,
							)
						}}
					>
						<svg
							fill={"none"}
							height={"33"}
							viewBox={"0 0 19 33"}
							width={"19"}
							xmlns={"http://www.w3.org/2000/svg"}
						>
							<path
								d={
									"M16.09 0.0001L18.1563 2.07302L4.13917 16.0901L18.1563 30.0964L16.09 32.1797L0.0004 16.0901L16.09 0.0001Z"
								}
								fill={"#0B1735"}
							/>
						</svg>
					</motion.button>

					<motion.button
						className={styles.navArrowRight}
						onClick={(e: any) => {
							e.stopPropagation()
							setActiveIndex((prev) =>
								typeof prev === "number"
									? (prev + 1) % data.length
									: 0,
							)
						}}
					>
						<svg
							fill={"none"}
							height={"33"}
							viewBox={"0 0 19 33"}
							width={"19"}
							xmlns={"http://www.w3.org/2000/svg"}
						>
							<path
								d={
									"M2.06625 32.1796L0 30.1067L14.0171 16.0896L0 2.08333L2.06625 0L18.1558 16.0896L2.06625 32.1796Z"
								}
								fill={"#0B1735"}
							/>
						</svg>
					</motion.button>
				</motion.div>
			)}
		</AnimatePresence>
	)
}

export default DefaultNavigationArrows
